// Icons — uses the FREE FontAwesome solid set (no Pro token required).
// If you restore a valid FontAwesome Pro token, you can switch the import
// back to '@fortawesome/pro-solid-svg-icons' and re-add sunrise/sunset/wifi-slash.
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faSpinner,
  faEnvelope,
  faKey,
  faBell,
  faSearch,
  faUser,
  faCheck,
  faCheckCircle,
  faTimes,
  faLock,
  faEllipsisH,
  faPlus,
  faCircle,
  faUserMd,
  faCogs,
  faCog,
  faSignOutAlt,
  faVial,
  faArrowRight,
  faFolderOpen,
  faClock,
  faCalendar,
  faArrowCircleLeft,
  faInfoCircle,
  faTrash,
  faPlusCircle,
  faMinusCircle,
  faArrowCircleRight,
  faArrowLeft,
  faCircleNotch,
  faSun,
  faMoon,
  faUserSlash,
  faPills,
  faPollH,
  faWifi,
  faEdit,
  faVials,
  faChevronRight,
  faWind,
  faUpload,
  faFile,
  faFileArchive,
  faBars,
  faDownload,
  faChartLine,
  faHistory,
  faTasks,
  faExclamationTriangle,
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faHistory,
  faTasks,
  faUpload,
  faFile,
  faFileArchive,
  faSpinner,
  faEnvelope,
  faKey,
  faBell,
  faSearch,
  faUser,
  faTimes,
  faLock,
  faEllipsisH,
  faPlus,
  faCircle,
  faUserMd,
  faCogs,
  faCog,
  faSignOutAlt,
  faVial,
  faCheckCircle,
  faCheck,
  faArrowRight,
  faFolderOpen,
  faClock,
  faCalendar,
  faArrowCircleLeft,
  faArrowCircleRight,
  faInfoCircle,
  faTrash,
  faPlusCircle,
  faMinusCircle,
  faArrowLeft,
  faCircleNotch,
  faSun,
  faMoon,
  faUserSlash,
  faPills,
  faPollH,
  faWifi,
  faEdit,
  faVials,
  faChevronRight,
  faWind,
  faBars,
  faDownload,
  faChartLine,
  faExclamationTriangle
)

export default FontAwesomeIcon
